export default __webpack_public_path__ + "static/media/item-1.affd49f0.webp";